import * as ACTIONS from "./../actions/actionConstants";

const initialState = {
  isOpen: false,
  message: "",
  variant: "info"
};

const snackbarReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.OPEN_SNACKBAR: {
      return {
        ...state,
        isOpen: true,
        message: action.payload.message,
        variant: action.payload.variant
      };
    }
    case ACTIONS.CLOSE_SNACKBAR: {
      return {
        ...state,
        isOpen: false,
        message: "",
        variant: "info"
      };
    }
    default: {
      return state;
    }
  }
};

export default snackbarReducer;



// WEBPACK FOOTER //
// ./src/reducers/snackbarReducer.js